var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlackCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M18.419 8.945l2.226-1.558-1.157-2.662-2.652.357-1.367-1.274V.974L13.05.038l-1.796 2.03H9.494L7.75 0 5.098 1.016v2.792L3.691 5.082l-2.637-.188L0 7.387l2.109 1.642v1.953l-2.07 1.773.98 2.29h2.98l1.099 1.307-.265 2.483L7.75 20l1.524-2.014h2.199l1.576 1.95 2.747-1.091-.327-2.557 1.279-1.243h2.879l.979-2.29-2.188-1.815V8.945zm-8.097 5.796c-2.711 0-4.91-2.123-4.91-4.741 0-2.618 2.199-4.74 4.91-4.74 2.712 0 4.91 2.122 4.91 4.74 0 2.618-2.198 4.74-4.91 4.74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlackCog);
export default __webpack_public_path__ + "static/media/icon-black-cog.7d1401740a7c231aa06d1857f1de405b.svg";
export { ForwardRef as ReactComponent };